import {makeAutoObservable} from "mobx";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {langTypes} from "../common/enums/ExcelEnum";

const logPrefix  = "[OddStepFourStore]"
export default class OddStepFourStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentList = [];
        this.originalContentList = [];
        this.selectedContent = '';
        this.contentTapIndex = 0;
        this.audio = null;
        this.refreshableList = [];

        makeAutoObservable(this);
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
    };

    getSelectedContent = () => {
        return this.contentList.filter(content => content.languageCode === this.getSelectedLangCode());
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getContent = (id) => {
        return this.contentList.find((c) => c.id === id);
    }

    isChangeContent = () => {
        return JSON.stringify(this.originalContentList) !== JSON.stringify(this.contentList);
    }

    changeText = (content, text) => {
        content.text = text;
    }

    playAudio = (id) => {
        if (this.audio) {
            this.stopAudio();
        }

        const contentAudio = this.contentList.find((c) => c.id === id).audio;
        const decodeAudio = atob(contentAudio);
        const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], { type: 'audio/mp3' });

        this.audio = new Audio();
        this.audio.id = id;
        this.audio.src = URL.createObjectURL(blob);
        this.audio.play();
    }

    stopAudio = () => {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    changeContentAudio = (content, audio) => {
        content.audio = audio;
        content.changeAudio = true;
    }

    getRefreshable = (id) => {
        return this.refreshableList.find((r) => r.id === id);
    }


    changeRefreshable = (id, isRefreshable, text) => {
        const refreshable = this.getRefreshable(id);
        if (refreshable) {
            refreshable.isRefreshable = isRefreshable;
            if (text) {
                refreshable.text = text
            }
        }
    }

    getChangeContentList = () => {
        return this.contentList.filter(c => {
            const originalContent = this.originalContentList.find(oc => oc.id === c.id);
            return originalContent && ((originalContent.text !== c.text) || originalContent.audio !== c.audio);
        });
    }

    * getOddStepFourContent(step, day, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getOddStepFourContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/4`;
            const response = yield this.contentRepository.getContent(url);

            this.contentList = response.data;
            this.refreshableList = [];
            for (const content of this.contentList) {
                this.refreshableList.push({id: content.id, isRefreshable: false, text: content.text})
            }
            this.originalContentList = JSON.parse(JSON.stringify(this.contentList));

            console.log(logPrefix, 'Finished getOddStepFourContent.');
            callback && callback(response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getOddStepFourContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyOddStepFourContent(step, day, callback) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyOddStepFourContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/4`;
            const response = yield this.contentRepository.putContent(url, this.getChangeContentList());
            console.log(logPrefix, 'Finished modifyOddStepFourContent : ', response);
            callback && callback();
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyOddStepFourContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

    isOddStepFourCompleted = (dataArray) => {
        const uniqueLangCounts = Array.from(new Set(dataArray.map(data => data.languageCode)));
        if (uniqueLangCounts.length < 4) {
            return false;
        }

        for (const uniqueLang of uniqueLangCounts) {
            const langContentList = dataArray.filter(data => data.languageCode === uniqueLang);
            if (langContentList.length < 9) {
                return false;
            }

            for (const langContent of langContentList) {
                if (langContent.audio === null) {
                    return false;
                }
            }
        }

        return true;
    }
}

